import { Column } from '@access-erp/common';
import { useEffect, useMemo, useRef } from 'react';

import { getHeaderColumns } from '../columns/headerColumns';
import { useGetredirectLink } from '@/components/common/EnquiriesScreen/utils/useGetRedirectLink';
import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';
import { browserHistory } from '@/routing/browserHistory';
import { goToRouteBySearch } from '@/components/common/EnquiriesScreen/utils/goToRouteBySearch';
import { contractsBCPath } from '@/utils/path.utlis';
import { useGetReasonCodes } from '@/pages/SystemAdmin/ReasonCodes/hooks/useGetReasonCodes';
import { PAUSE_BILLING_TYPE } from '@/config/reasonTypes.config';

export interface UseTransactionTableColumnsReturn {
  headerColumns: Column<any>[];
  goToContractLineBySearch: (searchText?: string) => void;
}

export const useColumns = (): UseTransactionTableColumnsReturn => {
  const getRedirectLink = useGetredirectLink();
  const { getReasonCodes, reasonCodes, isLoading } = useGetReasonCodes();

  const reasonCodesRef = useRef<ReasonCode[]>([]);
  
  useEffect(() => {
    reasonCodesRef.current = reasonCodes;
  }, [reasonCodes]);

  useEffect(() => {
    getReasonCodes(PAUSE_BILLING_TYPE, true);
  }, [getReasonCodes]);

  const PURCHASE_ORDERS_CONTRACT_LINES = '/purchase-orders/contract-lines/';

  const getContractLink = (contractId: string, searchString?: string) => {
    let link = getRedirectLink(window.location.pathname, contractId, searchString);

    if (link.includes(PURCHASE_ORDERS_CONTRACT_LINES)) {
      link = link.replace(
        PURCHASE_ORDERS_CONTRACT_LINES,
        `${PURCHASE_ORDERS_CONTRACT_LINES}${contractsBCPath}/`,
      );
    } else {
      link = link.replace('/contract-lines/', `/contract-lines/${contractsBCPath}/`);
    }
    return getParameterizedLink(link);
  };

  const goToContract = (contractLink: string) => {
    browserHistory.push(getParameterizedLink(contractLink));
  };

  const goToContractLineBySearch = (searchText?: string) => {
    goToRouteBySearch(searchText);
  };

  return useMemo(() => {
    const headerColumns = getHeaderColumns({ getContractLink, goToContract, reasonCodesRef });
    return {
      headerColumns,
      goToContractLineBySearch,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reasonCodes, isLoading]);
};
